import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api, daysUntil, fmtDate } from '../api';
import { useData } from '../App';
import { DeleteButton, Empty } from '../ui';
import { hasGuide } from '../data/setGuides';

export default function Utgafur() {
  const { sets, refresh } = useData();
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [date, setDate] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.addSet({ name: name.trim(), code: code.trim(), release_date: date });
      setName('');
      setCode('');
      setDate('');
      await refresh();
    } finally {
      setBusy(false);
    }
  }

  async function remove(id: number) {
    await api.delSet(id);
    await refresh();
  }

  return (
    <div className="view">
      <div className="g-two">
        <section className="card col-8">
          <div className="card-h">
            <h2>Útgáfudagar</h2>
            <span className="lbl">Staðfestið á wizards.com</span>
          </div>

          {sets.length === 0 ? (
            <Empty title="Engar útgáfur skráðar" body="Bættu við næstu settum hér til hægri." />
          ) : (
            <div className="tw" style={{ minWidth: 0 }}>
              <div>
                {sets.map((s) => {
                  const d = daysUntil(s.release_date);
                  const past = d !== null && d < 0;
                  return (
                    <div key={s.id} className={`rel${past ? ' past' : ''}`}>
                      <span className="dd">
                        {past ? '—' : d}
                        <small>{past ? 'liðið' : 'dagar'}</small>
                      </span>
                      <span className="info">
                        <Link to={`/utgafur/${s.id}`}>
                          <b>{s.name}</b>
                        </Link>
                        <span>
                          {s.code ? `${s.code} · ` : ''}
                          {fmtDate(s.release_date)}
                          {hasGuide(s.code) ? <span className="chip gold rel-guide">Leiðarvísir</span> : null}
                        </span>
                      </span>
                      <DeleteButton label={`Eyða ${s.name}`} onClick={() => void remove(s.id)} />
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </section>

        <section className="card col-4">
          <div className="card-h">
            <h2>Ný útgáfa</h2>
          </div>
          <form className="form" onSubmit={submit}>
            <div className="fld">
              <label className="lbl" htmlFor="s-name">Heiti setts</label>
              <input
                id="s-name"
                type="text"
                placeholder="Nafn settsins"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="fr">
              <div className="fld">
                <label className="lbl" htmlFor="s-code">Kóði</label>
                <input
                  id="s-code"
                  type="text"
                  maxLength={6}
                  placeholder="ABC"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>
              <div className="fld">
                <label className="lbl" htmlFor="s-date">Útgáfudagur</label>
                <input id="s-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} required />
              </div>
            </div>
            <button className="btn ghost" type="submit" disabled={busy || !name.trim() || !date}>
              Bæta við útgáfu
            </button>
          </form>

          <p style={{ marginTop: 18, fontSize: 12.5, color: 'var(--ink-3)', lineHeight: 1.5 }}>
            Útgáfudagar stýra hvenær borgar sig að halda forútgáfukvöld og hvenær hópinnkaup eiga
            að fara fram. Smelltu á sett til að sjá öll spilin í því — og leiðarvísi þar sem hann er til.
          </p>
        </section>
      </div>
    </div>
  );
}
